/*
//-------------------------------------------------------
//   Copyright (c) 2020 Templa Computer Systems Ltd
//
//   App:        EmployeePortal.UI
//   Object:     TCSInputNumeric.js
//   Details:    TCSInputNumeric.js
//
//
// Log      Date   By  Scan Description
// -----  -------- --- ---- ------------------------------
// 108737 14/08/20 JC       Added
//-------------------------------------------------------
*/

import React from 'react';

class TCSInputNumeric extends React.Component {

    /* function to handle focus, forcing the select of the entire input */
    handleFocus = (event) => event.target.select();

    render() {
        return (
            <input
                type="number" /* numeric input */
                onFocus={this.handleFocus} /* function  to handle focus as above */
                {...this.props} /* this line allows any other props to function as normal */
            />
        );
    }
}

export default TCSInputNumeric; 
